import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConfigProveedorTipo = {

    async Get() {  return await methods.Get("ConfigProveedorTipo/Get" ); },
    async Post(data) { return await methods.Post("ConfigProveedorTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("ConfigProveedorTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConfigProveedorTipo/Delete" + useParamsJson(qs)) }
};

export default ConfigProveedorTipo;